module.exports = __webpack_public_path__ + "img/bg-logo.45d75d46.png";